import { FC } from 'react';
import { useSelector } from 'react-redux';

import { setRegisterData, nextRegisterStep, setItSystem } from 'modules/auth/actions';
import { dispatch } from 'store';
import { Input, Select, Button } from 'views/components';
import { RootState } from 'types';

import { t } from 'utils';
import styles from './FirstStep.module.css';
import texts from '../../../texts';

export const FirstStepCompany: FC = () => {
  // store
  const { registerData, itSystem } = useSelector((state: RootState) => state.auth);

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    dispatch(setRegisterData(name, value));
  };

  const countOfClinics = ['6-25', '26-50', '50+'];

  const disabled = !registerData.clinicName || !registerData.yourPosition;
  return (
    <div className={styles.container}>
      <p>
        {t(texts.general.step)} 1 {t(texts.general.of)} 3
      </p>
      <h1 style={{ fontSize: 40, fontWeight: 'bold', lineHeight: '50px' }}>
        {t(texts.companyFirstStepTitle)}
      </h1>
      <p style={{ fontSize: '14px' }}>{t(texts.companyFirstStepDesc)}</p>
      <Input
        name="clinicName"
        value={registerData.clinicName}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.companyFirstStepInputLabel1)}
        maxLength={64}
      />
      <Input
        name="yourPosition"
        value={registerData.yourPosition}
        onChange={(e: any) => handleInputChange(e)}
        label={t(texts.companyFirstStepInputLabel2)}
        maxLength={64}
      />
      <div className={styles.items}>
        <div className={styles.item}>
          <Select
            name="howManyClinics"
            onChange={(e: any) => handleInputChange(e)}
            data={countOfClinics}
            label={t(texts.companyFirstStepInputLabel4)}
          />
        </div>
        {/* <div className={styles.item}>
          <Select
            name="howManyCamerasCompany"
            onChange={(e: any) => handleInputChange(e)}
            data={countOfCameras}
            label="Number of retinal cameras"
          />
        </div> */}
      </div>
      <div style={{ width: '253px' }}>
        <p style={{ fontSize: '12px' }}>{t(texts.companyFirstStepInputLabel5)}</p>
        <label style={{ marginRight: '10px' }}>
          <input
            style={{ width: '10px' }}
            type="radio"
            checked={itSystem === true}
            value="Yes"
            onClick={() => dispatch(setItSystem(true))}
          />
          {t(texts.companyFirstStepInputLabel6)}
        </label>
        <label>
          <input
            style={{ width: '10px' }}
            type="radio"
            checked={itSystem === false}
            value="No"
            onClick={() => dispatch(setItSystem(false))}
          />
          {t(texts.companyFirstStepInputLabel7)}
        </label>
      </div>
      <div style={{ marginTop: '40px', marginBottom: '50px', width: '150px' }}>
        <Button
          disabled={disabled}
          title={t(texts.companyFirstStepbuttonText)}
          onClick={() => {
            dispatch(nextRegisterStep())}
          }
        />
      </div>
    </div>
  );
};
